import { CascadiaButtonProps } from "@certn/cascadia/components/button/types";

import { _Button } from "./_Button";

interface Props extends CascadiaButtonProps {
  slot?: string;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function DangerButton(props: Props) {
  const { testID = "danger-button" } = props;

  return (
    <_Button
      color="text-inverse"
      fill="background-danger-strong"
      focusStyle="focus-action"
      hoverFill="background-danger-strong-hover"
      shadow="shadow-button"
      testID={testID}
      {...props}
    />
  );
}
